export default "__VITE_ASSET__B45dhDFU__"